export const API_URL_VOUCHERS_V2 = "/shop/api/v2/vouchers";
